export default function initializePatrons() {
    document.querySelectorAll('.block-patrons__grid').forEach(function (grid) {
        new Patrons(grid);
    });
}

class Patrons {
    constructor(grid) {
        this.grid = grid;
        this.items = Array.from(grid.querySelectorAll('.block-patrons__item'));
        this.active = null;
        this.init();
    }

    init() {
        this.items.forEach((item) => {
            const toggle = item.querySelector('.block-patrons__logo');
            const details = this.grid.querySelector('.block-patrons__details[data-patron-details="' + item.dataset.patronIndex + '"]');

            toggle.addEventListener('click', () => {
                const wasActive = item.classList.contains('active');
                const previousActive = this.active;

                if (previousActive) {
                    this.close(previousActive);
                    this.active = null;
                }

                if (!wasActive) {
                    this.open(item, toggle, details);
                }
            });
        });

        window.addEventListener('resize', () => {
            if (this.active) {
                this.position(this.active.item, this.active.details);
            }
        });
    }

    open(item, toggle, details) {
        item.classList.add('active');
        toggle.setAttribute('aria-expanded', 'true');

        this.position(item, details);
        details.classList.add('is-visible');

        // wymuszenie reflow, żeby przejście z 0fr na 1fr faktycznie się zaanimowało
        void details.offsetHeight;

        details.classList.add('active');

        this.active = { item, toggle, details };
    }

    close(entry) {
        entry.item.classList.remove('active');
        entry.toggle.setAttribute('aria-expanded', 'false');
        entry.details.classList.remove('active');

        entry.details.addEventListener('transitionend', function onEnd(event) {
            if (event.propertyName !== 'grid-template-rows') {
                return;
            }
            entry.details.classList.remove('is-visible');
            entry.details.removeEventListener('transitionend', onEnd);
        });
    }

    position(item, details) {
        const columns = getComputedStyle(this.grid).gridTemplateColumns.split(' ').length;
        const index = this.items.indexOf(item);
        const rowEndIndex = Math.min(this.items.length - 1, Math.ceil((index + 1) / columns) * columns - 1);
        const rowEndItem = this.items[rowEndIndex];

        rowEndItem.insertAdjacentElement('afterend', details);
    }
}
